import { Link } from "react-router-dom"
import { DevStatus, protectedRoutes, publicRoutes } from "@/app/routes/routeConfig"

export function TestIndexPage() {
  const getStatusColor = (status?: number) => {
    switch (status) {
      case 3:
        return "bg-green-100 text-green-800"
      case 2:
        return "bg-yellow-100 text-yellow-800"
      default:
        return "bg-gray-100 text-gray-800"
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <p className="text-sm text-gray-500">開発用ルート一覧</p>
        </div>

        <div className="space-y-8">
          {[...publicRoutes, ...protectedRoutes].map((category) => (
            <div key={category.category} className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
                <div className="flex items-center">
                  <div className="h-5 w-5 bg-gray-400 rounded mr-2" />
                  <h2 className="text-lg font-semibold text-gray-900">{category.category}</h2>
                </div>
              </div>
              <div className="divide-y divide-gray-200">
                {category.routes.map((route) => (
                  <div key={route.path}>
                    <Link
                      to={route.path}
                      className="block px-6 py-4 hover:bg-gray-50 transition-colors"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <h3 className="text-sm font-medium text-gray-900">{route.name}</h3>
                          <p className="text-xs text-gray-400 mt-1 font-mono">{route.path}</p>
                        </div>
                        <div className="flex gap-2 ml-4">
                          <div className="flex flex-col gap-1">
                            <span className="text-xs text-gray-500">View</span>
                            <span
                              className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(
                                route.viewStatus
                              )}`}
                            >
                              {route.viewStatus ? DevStatus[route.viewStatus] : "未設定"}
                            </span>
                          </div>
                          <div className="flex flex-col gap-1">
                            <span className="text-xs text-gray-500">API</span>
                            <span
                              className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(
                                route.apiStatus
                              )}`}
                            >
                              {route.apiStatus ? DevStatus[route.apiStatus] : "未設定"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
